import { PartyPopper, Ticket } from "lucide-react";

export const TICKETS_URL = "https://www.zeffy.com/en-CA/ticketing/dance-for-congo-edmonton";

export default function AnnouncementBar() {
  return (
    <div className="fixed inset-x-0 top-0 z-[55] bg-gold text-forest" data-testid="event-announcement-bar">
      <div className="mx-auto flex h-10 max-w-7xl items-center justify-center gap-2.5 px-4 sm:gap-3">
        <PartyPopper className="hidden h-4 w-4 shrink-0 sm:block" aria-hidden="true" />
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] sm:text-xs sm:tracking-[0.14em] md:text-sm" data-testid="announcement-text">
          <span className="hidden sm:inline">Dance for Congo — Edmonton Edition (3rd Edition)</span>
          <span className="sm:hidden">Dance for Congo · Edmonton</span>
          <span className="hidden md:inline"> · October 30th · 7:15 PM · Edmonton, Alberta (TBD)</span>
          <span className="hidden sm:inline md:hidden"> · Oct 30 · 7:15 PM</span>
          <span className="sm:hidden"> · Oct 30</span>
        </p>
        <a
          href={TICKETS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announcement-tickets-button"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-forest px-3.5 py-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-gold transition-transform duration-200 hover:scale-105 sm:text-[11px]"
        >
          <Ticket className="h-3.5 w-3.5" aria-hidden="true" />
          Get Your Tickets
        </a>
      </div>
    </div>
  );
}
